/**
 * The plugin registry - the browser twin of backend services/game_builder/mechanics/registry.py.
 * Every mechanic the player knows (a compare op, an effect, an interaction, a control, a relation, a
 * kind's visuals, a close-up) is a named, versioned plugin in one of these, so adding a mechanic is
 * registering it in one place instead of editing the engine and the player separately.
 * Plugins keep their registration order (the order they're tried in) and ids are unique.
 */
export function createRegistry(what) {
  const plugins = new Map();
  return {
    what,
    register(plugin) {
      if (!plugin || !plugin.id) throw new Error(`a ${what} needs an id`);
      if (plugins.has(plugin.id)) throw new Error(`${what} '${plugin.id}' is already registered`);
      plugins.set(plugin.id, { version: 1, ...plugin });
      return plugins.get(plugin.id);
    },
    get: (id) => plugins.get(id),
    has: (id) => plugins.has(id),
    ids: () => [...plugins.keys()],
    all: () => [...plugins.values()],
    /** The first plugin whose `match(...args)` is true (registration order). */
    find: (...args) => [...plugins.values()].find((p) => p.match && p.match(...args)),
    versions: () => Object.fromEntries([...plugins.values()].map((p) => [p.id, p.version]))
  };
}
